import {inject, ref} from "vue";

export default function useProjects() {
    const route = inject('route');
    const isLoadingProjects = ref(false);
    const projects = ref([]);

    const loadProjects = async () => {
        if(!projects.value.length) {
            isLoadingProjects.value = true;

            axios.get(route('api.v1.public.account.projects.index'))
                .then(response => projects.value = response.data.projects)
                .catch(error => console.log('error', error))
                .finally(() => isLoadingProjects.value = false);
        }
    }

    return {
        // refs
        isLoadingProjects,
        projects,
        // functions
        loadProjects,
    };
}
